

import React from 'react';
import { useCookieConsent } from '../context/CookieContext';

const CookieConsentOverview = () => {
  const { consent, resetConsent } = useCookieConsent();

  const handleReopenConsent = () => {
    // Reset full consent (localStorage + cookie + internal state) so the banner can reappear
    resetConsent();
    window.location.reload();
  };

  return (
    <div className="text-white text-sm mb-4">
      <ul className="list-disc list-inside">
        <li>Necessary cookies: <strong>Always enabled</strong></li>
        <li>Analytics cookies: <strong>{consent.analytics ? 'Allowed' : 'Not allowed'}</strong></li>
        <li>Marketing cookies: <strong>{consent.marketing ? 'Allowed' : 'Not allowed'}</strong></li>
      </ul>
      <button
        type="button"
        onClick={handleReopenConsent}
        className="mt-4 px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 text-sm"
      >
        Change Your Consent Preferences
      </button>
    </div>
  );
};

export { CookieConsentOverview };